import { useLocation, Navigate, Outlet } from "react-router-dom"
import useAuth from "../../hooks/useAuth"
import { useSelector } from "react-redux"
import { selectCurrentToken } from "./authSlice"

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation()
    const { roles } = useAuth()
    const token = useSelector(selectCurrentToken)

    const hasAllowedRole = roles.some(role => allowedRoles.includes(role))
    const isAuthenticated = Boolean(token)

    const content = hasAllowedRole
        ? <Outlet />
        : isAuthenticated
            ? <Navigate to="/forbidden" state={{ from: location }} replace />
            : <Navigate to="/public/login" state={{ from: location }} replace />

    return content
}
export default RequireAuth